import { useQuery } from "@tanstack/react-query"

import { useAuth } from "src/context/AuthContext"

export function useLLMAvailable() {
  const { api } = useAuth()

  return useQuery({
    queryKey: ["llm", "available"],
    queryFn: async () => {
      const response = await api.getLLMsAvailable()
      if (response.kind === "ok") {
        return response.llmConfig || []
      }
      return []
    },
  })
}
